import React from "react";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { renderCurrency, renderTextArea } from '../../Utils/renderField';
import { connect } from "react-redux";

const RefundModal = ({
    closeModal,
    handleSubmit,
}) => (
    <form name="refundMountForm" className="row" onSubmit={handleSubmit}>

        <div className="col-8">
            <Field
                name="amount"
                component={renderCurrency}
                className="form-control"
                label="Amount"
            />
            <br style={{borderTop: "None"}}/>
            <Field
                name="agent_notes"
                component={renderTextArea}
                rows="3"
                label="Agent Notes"
            />
        </div>
        <div className="col-4">
            <button className="btn btn-primary mb-2" type="submit">
                Process
            </button>
            <button className="btn btn-link" type="button" onClick={closeModal}>
                Cancel
            </button>
        </div>
    </form>
)

const formModal = reduxForm({
    form: "refundMountForm",
    validate: (data, {dataReservation, isCancel}) => {
        const errors = {};
        if(!data.amount){
            errors.amount = "Required field"
        } else if (data.amount > 0){
            if (dataReservation.data && data.amount > (dataReservation.data.transactionAmount - dataReservation.data.totalRefund)){
                errors.amount = "The amount is higher than the transaction"
            }
        } else if(!isCancel){
            errors.amount = "The amount must be greater than zero"
        } else{
            if(data.amount < 0){
                errors.amount = "The amount must not be less than zero"
            }
        }
        return errors;
    },
})(RefundModal);

const mstp = (state) => ({
    dataReservation: state.refund,
});

export default connect(mstp)(formModal);
